

export const veoShowcase = {
    header: 'AI 生成视频',
    badge: 'AI 视频',
    title: '文字转视频',
    subtitle:
      '通过详细文字描述传达创意，生成电影级内容，具备原生音频与逼真运动效果',
    promptLabel: '提示词',
    promptText:
      '一段极具电影质感的无人机航拍镜头，从夜幕降临、霓虹闪烁的未来都市雨景全景开始，流畅地滑翔至一只闪耀着蓝光的蝴蝶落在湿漉漉的金属栏杆上的特写。蝴蝶落地时，翅膀闪烁着光芒，完美地映照在雨滴中。镜头运动流畅而专业，动态模糊效果逼真，背景虚化效果极佳。8K分辨率，纹理细节丰富，色彩鲜艳，充满赛博朋克风格。'
  };
